import {Component, Input, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit, OnInit} from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';
import {TypeLoading} from "@app/enums";
import {environment} from "@env/environment";
import { Passenger } from '@app/models/micro/passenger.model';
import { Reservation } from '@app/models/micro/reservation.model';
import { ApiService } from '@app/services/micro/api.service';
import { GlobalsService } from '@app/services/micro/globals.service';
import { SeatsService } from '@app/services/seats.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from "@shared/shared.module";
import { PassengerService } from "@services/micro/passenger.service";
/**
  Componente que genera el QR de la Reservación
**/
@Component({
    selector: 'app-am-qrcode',
    templateUrl: './am-qrcode.component.html',
    styleUrls: ['./am-qrcode.component.scss'],
    standalone: false
})
export class AmQrcodeComponent implements OnInit {
  @Input() qrdata = '';
  @Input() width = 200;
  @Input() errorCorrectionLevel: 'L' | 'M' | 'Q' | 'H' = 'M';
  @Input() cssClass = 'center';
  @Input() colorDark = '#000000ff';
  @Input() colorLight = '#ffffffff';
  @Input() elementType: 'canvas' | 'img' | 'svg' = 'canvas';
  @Input() imageSrc?: string;
  @Input() imageHeight?: number;
  @Input() imageWidth?: number;
  @Input() margin?: number;

  url = '';
  reservation: Reservation;
  language: string = '';

  constructor(
    private _globalService: GlobalsService,
    private _translateService: TranslateService
  ) {}

  ngOnInit(): void {
    if (!this.qrdata) {
      this.initDefaultUrl();
    }
  }

  private initDefaultUrl(): void {
    this.reservation = this._globalService.getReservation();
    this.language = this._translateService.currentLang;
    this.qrdata = `${environment.urlWeb}myb/es-mx/reembolsos?last-name=${this.reservation?.passengers[0]?.lastName}&pnr=${this.reservation?.pnr}&utm_source=kioscos`;
  }
}
